module.exports = __webpack_public_path__ + "img/right_white.f0304a44.svg";